export default __webpack_public_path__ + "static/media/language.b69d0f0e.svg";